export default __webpack_public_path__ + "static/media/HeroImage.9bc71952.svg";